// extracted by mini-css-extract-plugin
module.exports = {"overlay":"preloader_overlay__8xjyj","preloader":"preloader_preloader__znZXp"};